import * as React from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "@/components/ui/table";

import { useDict } from "../../../app/[lang]/providers/DictionaryProvider";

interface EbaRetailTableProps {
  totalBunga: number[]; // [lump sum, reinvest pokok, reinvest pokok+bunga]
  ipr: string[]; // [lump sum, reinvest pokok, reinvest pokok+bunga]
}

export function EbaRetailTable({ totalBunga, ipr }: EbaRetailTableProps) {
  const dict = useDict();
  return (
    <Table className="w-full [&_th]:!bg-primary-700 [&_th]:!text-white [&_th]:!text-wrap">
      <TableHeader>
        <TableRow>
          <TableHead className="bg-primary-700"></TableHead>
          <TableHead className="text-center text-wrap bg-primary-700">{dict.ebaRetail.lumpSumHeader}</TableHead>
          <TableHead className="text-center text-wrap bg-primary-700">{dict.ebaRetail.reinvestPokokHeader}</TableHead>
          <TableHead className="text-center text-wrap bg-primary-700">{dict.ebaRetail.reinvestPokokBungaHeader}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow>
          <TableCell className="font-semibold text-wrap">{dict.ebaRetail.totalBunga}</TableCell>
          <TableCell className="text-center">{totalBunga[0] > 0 ? `Rp. ${totalBunga[0].toLocaleString("id-ID")}` : '-'}</TableCell>
          <TableCell className="text-center">{totalBunga[1] > 0 ? `Rp. ${totalBunga[1].toLocaleString("id-ID")}` : '-'}</TableCell>
          <TableCell className="text-center">{totalBunga[2] > 0 ? `Rp. ${totalBunga[2].toLocaleString("id-ID")}` : '-'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="font-semibold text-wrap">{dict.ebaRetail.annualReturn}</TableCell>
          <TableCell className="text-center">{ipr[0]}</TableCell>
          <TableCell className="text-center">{ipr[1]}</TableCell>
          <TableCell className="text-center">{ipr[2]}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}
